import Text from '@components/Ui/Text'
import Icon from '@components/Ui/Icon'
import Loader from '@components/Ui/Loader'
import classNames from 'classnames'
// import PropTypes from '@utils/prop-types'
import styles from './Button.scss'

const Button = ({
  children,
  onClick,
  theme,
  loading,
  disabled,
  block,
  narrow,
  e2eType,
  withIcon,
}) => (
  <div
    className={classNames(styles.base, styles[`theme-${theme}`], {
      [styles.loading]: loading,
      [styles.disabled]: disabled,
      [styles.block]: block,
      [styles.narrow]: narrow,
      [styles.withIcon]: withIcon,
    })}
    data-e2e={`appointments-${e2eType}`}
    onClick={!disabled ? onClick : undefined}
  >
    {loading && (
      <div className={styles.loader}>
        <Loader color="#faba00" />
      </div>
    )}
    {withIcon && (
      <div className={styles.icon}>
        <Icon type={withIcon} size={24} />
      </div>
    )}
    <Text type="slab_sm_bold">{children}</Text>
  </div>
)

Button.defaultProps = {
  onClick: () => {},
  loading: false,
  narrow: false,
  withIcon: false,
  theme: 'default',
  e2eType: 'button',
}
Button.propTypes = {}

export default Button
